import type { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';

import type { BaseProps, ForwardProps } from '../../types';
import { defaultThemeProp } from '../../theme';

export interface RectangleSkeletonProps extends BaseProps {
  /**
   * Width of the skeleton.
   * @default 'auto'
   */
  width?: string | number;
  /**
   * Height of the skeleton.
   * @default 'auto'
   */
  height?: string | number;
  /**
   * Variant of the skeleton.
   * @default 'default'
   */
  variant?: 'default' | 'button';
}

const defaultProps: Partial<RectangleSkeletonProps> = {
  width: 'auto',
  height: 'auto',
  variant: 'default'
};

export const StyledRectangleSkeleton = styled.div<Partial<RectangleSkeletonProps>>(props => {
  const { width, height, variant } = props;
  const { skeleton: skeletonBackground } = props.theme.base.palette;
  const { 'border-radius': borderRadius } = props.theme.base;
  return css`
    margin: 0.25rem;
    background-color: ${skeletonBackground};
    ${variant === 'button'
      ? `border-radius: calc(2 * ${borderRadius});
      width: 6.875rem;
      height: 2rem`
      : `width: ${width};
      height: ${height}`}
  `;
});

StyledRectangleSkeleton.defaultProps = defaultThemeProp;

const RectangleSkeleton: FunctionComponent<RectangleSkeletonProps & ForwardProps> = (
  props: RectangleSkeletonProps
) => {
  return <StyledRectangleSkeleton {...props} aria-disabled />;
};

RectangleSkeleton.defaultProps = defaultProps;

export default RectangleSkeleton;
